/**
 * Die kleine Datenbank auf dem Geraet.
 *
 * Zwei Regale, eine Datenbank:
 *
 *   auftraege  Was noch raus muss, die Warteschlange.
 *   ablage     Antworten der API, damit die Anwendung ohne Netz etwas
 *              anzuzeigen hat.
 *
 * Bewusst nicht zwei getrennte Datenbanken. Zwei Datenbanken heissen zwei
 * Versionsstaende, die auseinanderlaufen koennen, und in IndexedDB ist eine
 * Versionsaenderung der einzige Zeitpunkt, an dem sich Regale anlegen lassen.
 * Eine Datenbank mit allen Regalen ist die Fassung, die man in zwei Jahren
 * noch versteht.
 *
 * In der Ablage steht ausschliesslich, was der angemeldete Mensch ohnehin
 * sehen darf, und sie wird beim Abmelden geleert. Ein fremdes Geraet findet
 * dort nichts, was es nicht auch im Browser gefunden haette.
 */

const NAME = "jornado";
const FASSUNG = 1;

export const REGAL_AUFTRAEGE = "auftraege";
export const REGAL_ABLAGE = "ablage";

let verbindung: Promise<IDBDatabase> | null = null;

function oeffnen(): Promise<IDBDatabase> {
  if (verbindung) return verbindung;
  verbindung = new Promise<IDBDatabase>((fertig, fehlgeschlagen) => {
    const anfrage = indexedDB.open(NAME, FASSUNG);
    anfrage.onupgradeneeded = () => {
      const db = anfrage.result;
      if (!db.objectStoreNames.contains(REGAL_AUFTRAEGE)) {
        db.createObjectStore(REGAL_AUFTRAEGE, { keyPath: "id" });
      }
      if (!db.objectStoreNames.contains(REGAL_ABLAGE)) {
        db.createObjectStore(REGAL_ABLAGE, { keyPath: "pfad" });
      }
    };
    anfrage.onsuccess = () => fertig(anfrage.result);
    anfrage.onerror = () => fehlgeschlagen(anfrage.error);
  });
  return verbindung;
}

/** Eine Anfrage an ein Regal, als Zusage statt als Ereignis. */
export async function imRegal<T>(
  regal: string,
  modus: IDBTransactionMode,
  arbeit: (r: IDBObjectStore) => IDBRequest
): Promise<T> {
  const db = await oeffnen();
  return new Promise<T>((fertig, fehlgeschlagen) => {
    const vorgang = db.transaction(regal, modus);
    const anfrage = arbeit(vorgang.objectStore(regal));
    anfrage.onsuccess = () => fertig(anfrage.result as T);
    anfrage.onerror = () => fehlgeschlagen(anfrage.error);
  });
}

/**
 * Alles loeschen, was auf dem Geraet liegt.
 *
 * Beim Abmelden. Wer sich abmeldet, gibt das Geraet womoeglich weiter, und
 * dann darf dort weder ein Foto noch der Dienstplan von gestern liegen.
 * Wartende Auftraege gehen dabei mit verloren, deshalb fragt die Oberflaeche
 * vorher, wenn welche da sind.
 */
export async function allesLoeschen(): Promise<void> {
  await Promise.all([
    imRegal(REGAL_AUFTRAEGE, "readwrite", (r) => r.clear()),
    imRegal(REGAL_ABLAGE, "readwrite", (r) => r.clear())
  ]);
}
